import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { db, push, ref, set } from '../common/firebase';

const createNotification = async (notificationData) => {
  const notificationsRef = ref(db, 'notifications');
  const newNotificationRef = push(notificationsRef);
  await set(newNotificationRef, notificationData);
};


export const addSuggestion = createAsyncThunk(
  'suggestions/addSuggestion',
  async (suggestion, { rejectWithValue }) => {
    try {
      const timestamp = Date.now();
      const suggestionData = {
        ...suggestion,
        createdAt: timestamp,
      };
      const suggestionsRef = ref(db, 'suggestions');
      const newSuggestionRef = push(suggestionsRef);
      await set(newSuggestionRef, suggestionData);

      await createNotification({
        Category: 'suggestion',
        mood: null,
        action: 'addSuggestion',
        contentId: suggestion.userId,
        title: 'New Suggestion Received',
        description: `"${suggestion.username}" suggested a topic: "${suggestion.topic}"`,
        timestamp: Date.now(),
      });

      return { id: newSuggestionRef.key, ...suggestionData };
    } catch (error) {
      console.error('Error adding suggestion:', error);
      return rejectWithValue('Failed to add suggestion');
    }
  }
);

const suggestionsSlice = createSlice({
  name: 'suggestions',
  initialState: { suggestions: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addSuggestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSuggestion.fulfilled, (state, action) => {
        state.loading = false;
        state.suggestions.push(action.payload);
      })
      .addCase(addSuggestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default suggestionsSlice.reducer;
